
    import Vue from 'vue';
    import XSummary from '@/apps/shared/components/summary.vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import DateService from '@/apps/shared/utils/formatDate';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';


    export default Vue.extend({
        name: 'UrbanMobilitySummary',
        components: {
            XSummary,
        },
        data() {
            return {
                productDetails: {
                    GUiD: null,
                    product: "/movilidad",
                    effectDate: null,
                    expirationDate: null,
                    name: null,
                    email: null,
                    telephone: null,
                    cover: null,
                    planDescription: null,
                    firstPaymentFee: null,
                    capital: null,
                    undiscountedPrice: null,
                    rate: null,
                    cupeUrl: null,
                    breadcrumbItems: [
                        { text: 'Inicio', path: '/movilidad' },
                        { text: 'Resumen', path: 'movilidad/resumen' },
                    ],
                    icon: {
                        src: '/Logos/movilidad.svg',
                        alt: 'Movilidad',
                        title: 'Movilidad'
                    },
                } as SummaryDetails,
                pricingId: null,
                GUiD: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Movilidad urbana';
                var actualPath = '/movilidad';
                const actualStep = 'summary';

                const planData = JSON.parse(sessionStorage.getItem("PlanSelected"));
                const clientData = JSON.parse(sessionStorage.getItem("stepOneData"));
                const dataVehicle = JSON.parse(sessionStorage.getItem("ProductDataSelected"))
                const rangeSelected = JSON.parse(sessionStorage.getItem("ProductValueSelected"));

                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = clientData.lastName;
                request.firstName = clientData.firstName;
                request.phone = clientData.areaCode + clientData.telephone;
                request.mail = clientData.email;
                request.quotePlan = planData.planDescription;
                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Vehículo: " + dataVehicle.productDescription
                    + " - Valor: " + rangeSelected.productDescription;

                if (rutaAlternativa) {
                    actualPath = '/movilidad/elegiplan';
                }
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getCUPE: function () {
                var email = "";
                var productId = 936;
                NF.UI.Page.block();
                var timeStart = new Date().getTime();
                CUPEService.GetCUPEUrl(productId, email, this.GUiD).then(response => {
                    this.productDetails.cupeUrl = response.preferenceMessage;
                    var endTime = new Date().getTime();
                    var secondCharge = Math.round((endTime - timeStart) / 1000);
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': JSON.parse(sessionStorage.getItem("stepOneData")).email,  
                        'product': 'movilidad',
                        'event': 'cotizador-movilidad-resumen',
                        'carga': secondCharge,
                        'referente': this.referente
                    });
                    NF.UI.Page.unblock();
                }).catch((error) => {
                    console.error('Error al obtener la URL:', error);
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },
            setSessionParams() {
                const rawContratante = JSON.parse(sessionStorage.getItem('stepOneData')!);
                const rawPlan = JSON.parse(sessionStorage.getItem('PlanSelected')!);
                const rawVigencyStart = sessionStorage.getItem('vigencyStart');
                const rawVigencyEnd = sessionStorage.getItem('vigencyEnd');
                const rawLeadId = JSON.parse(sessionStorage.getItem("LeadId"));
                const rawProductData = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                const rawVehicleData = JSON.parse(sessionStorage.getItem("DataVehicle"));

                const payload = {
                    productId: 936,
                    pricingId: rawPlan.PricingId[0],
                    contratante: {
                        firstName: rawContratante.firstName,
                        lastName: rawContratante.lastName,
                        documentNumber: rawContratante.documentNumber,
                        documentType: rawContratante.documentType.id,
                        areaCode: rawContratante.areaCode,
                        telephone: rawContratante.telephone,
                        email: rawContratante.email
                    },
                    plan: {
                        planName: rawPlan.planDescription,
                        premioMensual: rawPlan.premioMensual,
                        sumAssured: rawPlan.groupOfAmparoTheftOptions[0].capital.toString()
                    },
                    vehicle: {
                        vehicleDescription: rawProductData.productDescription,
                        vehicleBrand: rawVehicleData.vehicleBrand,
                    },
                    localityId: rawContratante.address,
                    leadId: rawLeadId,
                    referente: this.referente,


                };

                const jsonString = JSON.stringify(payload);
              
                return ParamCotizService.setParamCotiz(jsonString)
                    .then(guid => {
                        this.GUiD = guid;
                    })
                    .catch(err => {
                        console.error("Error en setSessionParams:", err);
                    });
            },
            async fetchSessionPayload() {
                const guid = sessionStorage.getItem('ParamId');
                    if (guid)
                await ParamCotizService.getParamCotiz(guid);
             },

            async getUrbanMovilityDiscountRange() {
                NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                await DiscountRangeService.getUrbanMovilityDiscountRange().then((response) => {
                    if (response.length > 0) {
                        this.productDetails.rate = response[0].discountMaxValue;
                    }
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },
            async getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const today = new Date();
                const nextYearDate = new Date(today);
                nextYearDate.setFullYear(today.getFullYear() + 1);
                this.productDetails.effectDate = DateService.formatDate(today);
                this.productDetails.expirationDate = DateService.formatDate(nextYearDate);
                const personData = JSON.parse(sessionStorage.getItem("stepOneData"));
                const planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected"));
                if (personData != null) {
                    this.productDetails.name = personData.firstName + ' ' + personData.lastName;
                    this.productDetails.email = personData.email;
                    this.productDetails.telephone = personData.areaCode + '-' + personData.telephone;
                }
                if (planDataSelected != null) {
                    this.productDetails.planDescription = planDataSelected.planDescription;
                    this.productDetails.firstPaymentFee = planDataSelected.premioMensual;
                    this.productDetails.capital = planDataSelected.groupOfAmparoTheftOptions.find(o => o.coverDescription.trim() == "Robo Movilidad").capital;
                    this.productDetails.undiscountedPrice = planDataSelected.premiumWithoutDiscount;
                    this.productDetails.cover = planDataSelected.groupOfAmparoTheftOptions;
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                await this.fetchSessionPayload();

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getUrbanMovilityDiscountRange(),
                    this.getInitData(),
                    this.setSessionParams()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getCUPE();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
